import { useCallback } from 'react';
import { TenantCountryCodeEnum } from '../api';
import { useTenant } from '../module/me';

export function withForceKeycloak(url: string, path?: string): string {
  const parsedUrl = new URL(url);

  if (path) {
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    const parsedPath = new URL(normalizedPath, parsedUrl.origin);
    parsedUrl.pathname = parsedPath.pathname;
    parsedUrl.search = parsedPath.search;
    parsedUrl.hash = parsedPath.hash;
  }

  parsedUrl.searchParams.set('force_keycloak', 'true');
  return parsedUrl.toString();
}

function readViteEnv(key: string): string | undefined {
  return (import.meta.env as unknown as Record<string, string | undefined>)[key];
}

function getBikeleasingPortalUrl(countryCode?: string): string {
  const defaultUrl = readViteEnv('VITE_BIKELEASING_PORTAL_URL');
  const deploymentEnvironment = readViteEnv('VITE_SENTRY_ENVIRONMENT');
  const isProductionDeployment = deploymentEnvironment ? deploymentEnvironment === 'production' : !!import.meta.env.PROD;

  if (isProductionDeployment && countryCode === TenantCountryCodeEnum.At) {
    return readViteEnv('VITE_BIKELEASING_PORTAL_URL_AT') ?? 'https://portal.bikeleasing.at';
  }

  return defaultUrl ?? '';
}

export function withForceKeycloakBikeleasing(countryCode?: string, path?: string): string {
  const portalUrl = getBikeleasingPortalUrl(countryCode);
  if (!portalUrl) {
    return '';
  }
  return withForceKeycloak(portalUrl, path);
}

export function useBikeleasingPortalLinkBuilder(): (path?: string) => string {
  const { tenant } = useTenant();
  const countryCode = tenant?.countryCode;

  return useCallback((path?: string) => withForceKeycloakBikeleasing(countryCode, path), [countryCode]);
}
